import { css } from '@/styled-system/css';

/**
 * Constellation's loading shimmer (the PropertyCard `loading` recipe), applied while `data-loading` is set:
 * a 386px `bg.softest` highlight sweeping across `bg.softer` with the Constellation preset `shimmer`
 * keyframes at `durations.1500`, and no animation when the user prefers reduced motion.
 *
 * @returns {ReturnType<typeof css.raw>} Raw CSS styles object for the shimmer effect
 */
export const shimmerStyles = css.raw({
  _loading: {
    color: 'transparent',
    opacity: 'inherit',
    backgroundColor: 'bg.softer',
    backgroundImage: 'linear-gradient(to right, {colors.bg.softer}, {colors.bg.softest}, {colors.bg.softer})',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '386px',
    _motionReduce: {
      animation: 'none',
    },
    _motionSafe: {
      animationName: 'shimmer',
      animationDuration: '{durations.1500}',
      animationIterationCount: 'infinite',
    },
  },
});
